/* Icon — SVG sprite at /icons-ds.svg (public) */
import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
    name: string;
    className?: string;
    size?: number;
}

const Icon: React.FC<IconProps> = ({ name, className = "", size, style, ...rest }) => (
    <svg
        className={["ic", className].filter(Boolean).join(" ")}
        style={size ? { width: size, height: size, ...style } : style}
        aria-hidden
        {...rest}
    >
        <use href={`/icons-ds.svg#${name}`} />
    </svg>
);

export default Icon;
